import { shift } from '@floating-ui/dom';
import { offset } from '@floating-ui/react';
import useDimensions from '../../../../hooks/useDimensions';
export function useFloatingUiMiddleware() {
  const {
    isMobile
  } = useDimensions();
  return isMobile ? [shift({
    mainAxis: true,
    crossAxis: true
  }), offset({
    crossAxis: 56
  })] : [offset({
    crossAxis: -74,
    mainAxis: -6
  })];
}